import { render } from "./NavBody.vue?vue&type=template&id=d2923a22&scoped=true"
import script from "./NavBody.vue?vue&type=script&lang=js"
export * from "./NavBody.vue?vue&type=script&lang=js"

import "./NavBody.vue?vue&type=style&index=0&id=d2923a22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2923a22"]])

export default __exports__